//#region IMPORT
/** 화면: 안전보건제안 — 조회/저장/삭제 API는 재해현황 아차사고(ACS_BASIC_02)와 동일(GetAccBasic02R1, SaveAccBasic02U1, DeleteAccBasic02D1). */
import React from 'react';
import { Unstable_Grid2 as Grid } from '@mui/material';
import { AuthButton } from '../../../../Components/MUIs';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { getColumnDefs1 } from './SUG_DAI_ColumnDefs';
import MemberInfoModal from '../../../../Components/MemberInfoModal/MemberInfoModal';
import GongjongSelectModal from '../../../../Components/GongjongSelectModal';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import dayjs from 'dayjs';
//#endregion

function SUG_DAI(props) {
  const columnDefs1 = getColumnDefs1(props);
  const getKey = (data) => data?.no ?? data?.nearMissSeq ?? data?.id;

  const conditions = [
    ...(props.userInfo?.authCd === 'ADMIN'
      ? [
          {
            type: 'combo',
            name: '회사',
            items: props.searchInfo?.coList ?? [],
            value: props.searchInfo?.coCd ?? '',
            onChange: (e) => {
              props.handleCoChange?.(e);
              if (props.validateSelection?.()) props.setSearchClick1?.(true);
            },
          },
        ]
      : []),
    {
      type: 'combo',
      name: '사업장',
      items: props.searchInfo?.custList ?? [],
      value: props.searchInfo?.custCd ?? '',
      onChange: (e) => {
        props.handleCustChange?.(e);
        if (props.validateSelection?.()) props.setSearchClick1?.(true);
      },
    },
    {
      type: 'combo',
      name: '부서',
      items: [
        { value: '', name: '전체' },
        ...(props.searchInfo?.depList ?? []),
      ],
      value: props.searchInfo?.depCd ?? '',
      onChange: async (e) => {
        await props.handleDepChange?.(e);
        if (props.validateSelection?.()) props.setSearchClick1?.(true);
      },
    },
    {
      type: 'combo',
      name: '공정',
      items: props.gongjongList ?? [],
      value: props.gongjongCd ?? '',
      onChange: (value) => {
        props.handleGongjongChange?.(value);
        if (props.validateSelection?.()) props.setSearchClick1?.(true);
      },
    },
    {
      type: 'datePicker',
      name: '년월',
      views: ['year', 'month'],
      openTo: 'month',
      value: dayjs(
        `${props.searchInfo?.year || dayjs().format('YYYY')}-${props.searchInfo?.month || dayjs().format('MM')}`,
        'YYYY-MM'
      ),
      onChange: (date) => {
        props.handleYearMonthChange?.(date);
        if (props.validateSelection?.()) props.setSearchClick1?.(true);
      },
      format: 'YYYY-MM',
      currentLocale: 'ko',
    },
    {
      type: 'combo',
      name: '상태',
      items: [
        { value: '', name: '전체' },
        { value: '0', name: '진행중' },
        { value: '1', name: '완료' },
      ],
      value: props.searchInfo?.gubun ?? '',
      onChange: (value) => {
        props.dispatch?.({
          type: 'SearchInfo/setGubun',
          payload: value ?? '',
        });
        if (props.validateSelection?.()) props.setSearchClick1?.(true);
      },
    },
  ];

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="SuggestionList"
          searchYn="Y"
          searchBox="Y"
          addYn="Y"
          saveYn="Y"
          deleteYn="N"
          printYn="N"
          placeholder="검색어(신청인,작성인)"
          searchClick={(searchTextFromBox) => {
            if (!props.validateSelection?.()) return;
            if (typeof searchTextFromBox === 'string') {
              props.setSearchText?.(searchTextFromBox);
            }
            props.setSearchClick1?.(true);
          }}
          saveClick={() => {
            if (!props.validateSelection?.()) return;
            props.setSaveClick1?.(true);
          }}
          printClick={() => {
            if (!props.validateSelection?.()) return;
            props.setPrintClick1?.(true);
          }}
          conditions={conditions}
          grids={
            <React.Fragment>
              <BusinessGridCommon
                getRowId={(params) =>
                  String(
                    params.data?.no ??
                      params.data?.nearMissSeq ??
                      params.data?.id ??
                      params.rowIndex
                  )
                }
                deleteYn1="Y"
                addYn1="Y"
                fileDownloadYn1="Y"
                fileDownloadClick1={() => {
                  if (!props.validateSelection?.()) return;
                  props.ExcelDownload1?.();
                }}
                autoHeaderHeight={true}
                stopEditingWhenCellsLoseFocus={false}
                gridRef={props.gridRef1}
                columnDefs={columnDefs1}
                rowData={props.rowData1}
                setSelectedRowData={props.setSelectedRowData1}
                setChangedRowData={props.setChangedRowData1}
                onCellEditingStarted={(e) => {
                  const api = props.gridRef1?.current?.api;
                  if (!api) return;
                  const key =
                    (e.data &&
                      (e.data.no ?? e.data.nearMissSeq ?? e.data.id)) ??
                    null;
                  const updatedRow = {
                    ...e.data,
                    editYn: 'Y',
                  };
                  e.node?.setData?.(updatedRow);
                  // 신규행(newYn)은 rowData1(조회 데이터)에 넣지 않고 그리드에만 둠
                  if (key != null && updatedRow.newYn !== 'Y') {
                    props.setRowData1?.((prev) => {
                      const list = prev || [];
                      const existing = list.find(
                        (r) => (r.no ?? r.nearMissSeq ?? r.id) === key
                      );
                      if (!existing) return [updatedRow, ...list];
                      return list.map((r) =>
                        (r.no ?? r.nearMissSeq ?? r.id) !== key
                          ? r
                          : { ...r, ...updatedRow }
                      );
                    });
                  }
                }}
                onCellEditingStopped={() => {
                  const api = props.gridRef1?.current?.api;
                  api?.stopEditing?.();
                  api?.clearFocusedCell?.();
                }}
                addClick1={() => {
                  if (!props.validateSelection?.()) return;
                  GridFunctions.addClick(
                    props.gridRef1,
                    { status: '0' },
                    { skipStartEdit: true }
                  );
                  const api = props.gridRef1?.current?.api;
                  setTimeout(() => {
                    const first = api?.getDisplayedRowAtIndex?.(0);
                    if (first?.data?.newYn === 'Y') {
                      props.rowClickData.current = {
                        rowIndex: first.rowIndex,
                        data: first.data,
                      };
                    }
                  }, 0);
                  props.setModalToggle1?.(true);
                }}
                refreshClick1={() => {
                  if (!props.validateSelection?.()) return;
                  props.SearchLogic1?.();
                }}
                deleteClick1={() => {
                  if (!props.validateSelection?.()) return;
                  const hasNew = props.selectedRowData1?.some(
                    (r) => r.newYn === 'Y'
                  );
                  if (hasNew) props.NewYnErrorMsg?.();
                  else props.MarkedForDeletion1?.(props.selectedRowData1);
                }}
                onCellValueChanged={(e) => {
                  const key = getKey(e.data);
                  const field =
                    e.column?.getColDef?.()?.field ?? e.colDef?.field;
                  const newVal =
                    e.newValue !== undefined
                      ? e.newValue
                      : field
                        ? e.data?.[field]
                        : undefined;

                  const updatedRow = {
                    ...e.data,
                    editYn: 'Y',
                    ...(field != null && newVal !== undefined
                      ? { [field]: newVal }
                      : {}),
                  };

                  e.node?.setData?.(updatedRow);

                  props.setChangedRowData1?.((prev) => {
                    const filtered = prev.filter((r) => getKey(r) !== key);
                    return [...filtered, updatedRow];
                  });
                  // 신규행은 rowData1에 반영하지 않음(그리드만). 기존 조회 행만 state 동기화
                  if (updatedRow.newYn !== 'Y') {
                    props.setRowData1?.((prev) => {
                      const list = prev || [];
                      const existing = list.find((r) => getKey(r) === key);
                      if (!existing) return [updatedRow, ...list];
                      return list.map((r) =>
                        getKey(r) !== key ? r : { ...r, ...updatedRow }
                      );
                    });
                  }
                }}
                onCellClicked={(e) => {
                  const gridApi = props.gridRef1?.current?.api;
                  if (!gridApi) return;
                  const isCheckboxClick = e.event?.target?.type === 'checkbox';
                  const colField =
                    e.column?.getColDef?.()?.field ?? e.colDef?.field;
                  const isDateTimeCell = colField === 'occurDate';
                  if (!isCheckboxClick && !isDateTimeCell) {
                    gridApi.ensureIndexVisible(e.rowIndex, 'middle');
                    const copied = JSON.parse(JSON.stringify(e.data));
                    props.handleRowSelection1?.(copied, e.rowIndex);
                    gridApi
                      .getDisplayedRowAtIndex(e.rowIndex)
                      ?.setSelected?.(true, false);
                  }
                }}
                onSelectionChanged={() => {
                  const gridApi = props.gridRef1?.current?.api;
                  const selectedNodes = gridApi?.getSelectedNodes() ?? [];
                  const selectedData = selectedNodes
                    .map((n) => n.data)
                    .filter(Boolean);
                  props.selectedRowNosRef1.current = new Set(
                    selectedData.map((r) => r.no)
                  );
                  props.setSelectedRowData1?.(selectedData);
                }}
              />
              <MemberInfoModal
                open={props.modalToggle1}
                onClose={() => props.setModalToggle1?.(false)}
                onSelection={props.HandleManageSelection1}
                columnVariant="accidentStatus"
              />
              <GongjongSelectModal
                open={props.gongjongModalToggle}
                onClose={() => props.setGongjongModalToggle?.(false)}
                onSelect={props.HandleGongjongSelection1}
                custCd={props.custCd}
                allowEmptySelection
                allowOtherOption
              />
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  );
}

export default SUG_DAI;
